/**
 * Global UI/client state: theme mode and sidebar collapse. Persisted so
 * the user's preferences survive reloads. Server state belongs in
 * TanStack Query, not here.
 */
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import type { ThemeMode } from '@/config/antd-theme'
import { STORAGE_KEYS } from '@/config/app.config'

interface UIState {
  themeMode: ThemeMode
  sidebarCollapsed: boolean

  setThemeMode: (mode: ThemeMode) => void
  toggleTheme: () => void
  setSidebarCollapsed: (collapsed: boolean) => void
  toggleSidebar: () => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      themeMode: 'light',
      sidebarCollapsed: false,

      setThemeMode: (themeMode) => set({ themeMode }),
      toggleTheme: () => set((s) => ({ themeMode: s.themeMode === 'light' ? 'dark' : 'light' })),
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
    }),
    {
      name: STORAGE_KEYS.ui,
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
